import { SFMainBtn, SFMainDialog } from './components';

import { useSubstitutionFlow } from './hooks';

import type { OrderId } from 'shared/domain';

export function SubstitutionFlow(props: Props) {
  const { orderId } = props;

  const {
    isRendered,
    showStartSFBtn,
    showCancelBtn,
    open,
    fromChatBtn,
    handleOpen,
    handleBack,
    handleClose,
    handleCancelOrder,
  } = useSubstitutionFlow({ orderId });

  if (!isRendered) return null;
  return (
    <>
      {showStartSFBtn && <SFMainBtn ctaMode='start-sf' onClick={handleOpen} />}

      {showCancelBtn && (
        <SFMainBtn ctaMode='cancel-order' onClick={handleCancelOrder} />
      )}

      {open && (
        <SFMainDialog
          open={open}
          orderId={orderId}
          fromChatBtn={fromChatBtn}
          onBack={handleBack}
          onClose={handleClose}
        />
      )}
    </>
  );
}

interface Props {
  orderId: OrderId;
}
